import { render, staticRenderFns } from "./NewTreatmentPatientDetailsModal.vue?vue&type=template&id=168f2f1c"
import script from "./NewTreatmentPatientDetailsModal.vue?vue&type=script&lang=js"
export * from "./NewTreatmentPatientDetailsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports